import {observer} from "mobx-react-lite";
import { useInjection } from "../../../react-binding";
import MortgageMathService from "../../../services/MathServices/MortgageMath.service";
import { MortgageParams, StringMortgageParams } from "../../../constants/types";
import { InputWithSlider } from "../partials/InputWithSlider";
import UserInfo from "../../../services/UserInfo.service";
import { action } from "mobx";
import { calcDisclaimer } from "../../../constants/constants";
import { useCallback, useEffect, useMemo, useState } from "react";
import { PrintHeader } from "../../main/PrintHeader";
import { BankService } from "../../../services/Bank/BankService";
import { getMostRecentNumericValue, numberToStringWithSpaces, sanitizeInput } from "../../../helpers/helpers";
import { Select } from "../partials/Select";
import { Line } from "react-chartjs-2";
import { PrintButton } from "../../main/PrintButton";
import { AnnuityCalcTableRow } from "./AnnuityCalcTableRow";
import { ImportExport } from "../partials/ImportExport";
import { PrintFooter } from "../../main/PrintFooter";
import './AnnuityCalc.scss';
import { Divider } from "../../partials/Divider";

//@observer
export const AnnuityCalc = observer(() => {

    const [recomputeRandomString, setRecomputeRandomString] = useState(Math.random().toString());

    const mortgageMathService = useInjection(MortgageMathService);
    const userInfoService = useInjection(UserInfo);
    const bankService = useInjection(BankService) as BankService;

    const [showPrintHeader, setShowPrintHeader] = useState<boolean>(false);
    const [annuityData, setAnnuityData] = useState([] as any[]);

    const [genericAnnuityData, setGenericAnnuityData] = useState([] as any[]);
//    const [extraAmountsOrPayments, setExtraAmountsOrPayments] = useState([] as any[]);
//    const [iRates, setIrates] = useState([] as any[]);
//    const [dues, setDues] = useState([] as any[]);
    const [monthlyData, setMonthlyData] = useState<boolean>(true);

    const [variableAmount, setVariableAmount] = useState(false);
    const [variableDue, setVariableDue] = useState(false);
    const [variableIRate, setVariableIRate] = useState(false);
    const [notesVisible, setNotesVisible] = useState(false);
//    const [notes, setNotes] = useState([] as any[]);

    const setOneNote = action((note: string, index: number) => {
        const newNotes = [...userInfoService.annuityCalcData.notes];
//        const newNotes = [...notes];
        newNotes[index] = note;
        userInfoService.annuityCalcData.notes = newNotes;
//        setNotes(newNotes);
    });

    const setStartingYear = action((newStartingYear: number) => {
        userInfoService.annuityCalcData.startingYear = newStartingYear;
    });

    const setOneExtraAmountOrPayment = action((newExtraAmountOrPayment: string, index: number) => {
        const annuityDataForIndex = annuityData[index];
        const currentExtraAmountForIndex = userInfoService.annuityCalcData.extraAmountsOfPayments[index] ?? 0;
        const extraAmountDiff = Number(newExtraAmountOrPayment) - currentExtraAmountForIndex;

        //        const currentAmountLeft = annuityDataForIndex.amount + annuityDataForIndex.interest - annuityDataForIndex.installment;
        if (annuityDataForIndex.amount + extraAmountDiff < 0) {
            // The user can't pay more than the amount left
            const newExtraAmountsOrPayments = [...userInfoService.annuityCalcData.extraAmountsOfPayments];
            newExtraAmountsOrPayments[index] = -annuityDataForIndex.amount;
            userInfoService.annuityCalcData.extraAmountsOfPayments = newExtraAmountsOrPayments;

            const newDues = [...userInfoService.annuityCalcData.dues];
            newDues[index] = 0;
            userInfoService.annuityCalcData.dues = newDues;
        } else {
        const newExtraAmountsOrPayments = [...userInfoService.annuityCalcData.extraAmountsOfPayments];
        newExtraAmountsOrPayments[index] = Number(newExtraAmountOrPayment);
        userInfoService.annuityCalcData.extraAmountsOfPayments = newExtraAmountsOrPayments;
//        setExtraAmountsOrPayments(newExtraAmountsOrPayments);
        }

        /*
        ANY TIME the amount is changed, we need to check if it is bigger than before
        If YES, we need to make sure that IF for the last year the DUE is SET to 0,
        we need to delete the hard set 0 due for the last year
        */
//TODO: use this for fixes, but not right now because there are still cases like
// we use this, but then we change previous change some more

        if (extraAmountDiff > 0) {
            // If we set previous year to more amount, then we will set the last year to less amout, which will result
            // in the zero disappearing
            const dues = userInfoService.annuityCalcData.dues;

            for (let i = dues.length; i >= 0; i--) {

                // We must check if after the new change there is positive amount left
                
                if (dues[i] === 0) {
                    delete userInfoService.annuityCalcData.dues[i];
                }
            }
        }
    });

    const recompute = action(() => {
        const data: MortgageParams = {};
        // @ts-ignore
        Object.keys(userInfoService.annuityCalcData).forEach((key: keyof StringMortgageParams) => {
            if (key !== userInfoService.annuityCalcData.computing) {
                // @ts-ignore
                data[key] = userInfoService.annuityCalcData[key]
            }
        });

        data[userInfoService.annuityCalcData.computing] = undefined;
        try {
            // Computes the missing parameter
            const result = mortgageMathService.calcMortgageViaMissingParam(data, true);
            userInfoService.annuityCalcData[userInfoService.annuityCalcData.computing] = Number(result).toLocaleString('cs');
            userInfoService.annuityCalcData.error = false;
        } catch(e) {
            userInfoService.annuityCalcData.error = true;
            console.warn(e);
        }

        // We have all data now, we can calculate the annuity calendar

        if (userInfoService.annuityCalcData.error ||
            userInfoService.annuityCalcData.amount === undefined ||
            userInfoService.annuityCalcData.iRate === undefined ||
            userInfoService.annuityCalcData.due === undefined ||
            userInfoService.annuityCalcData.installment  === undefined
        ) {
            return;
        }
        const newAnnuityData = mortgageMathService.calcAnnuityCalendar(
            {
                amount: userInfoService.annuityCalcData.amount,
                iRate: userInfoService.annuityCalcData.iRate,
                due: sanitizeInput(userInfoService.annuityCalcData.due)*12,
                installment: userInfoService.annuityCalcData.installment
            
            },
            userInfoService.annuityCalcData.extraAmountsOfPayments.map((val) => (-Number(val))),
            userInfoService.annuityCalcData.iRates.map((val) => Number(val)),
            userInfoService.annuityCalcData.dues.map((val) => Number(val))
        )

        setAnnuityData(newAnnuityData);

        const genericDues = [];
        const genericDue = sanitizeInput(userInfoService.annuityCalcData.due)*12;
        for (let i = 0; i <= genericDue; i++) {
            genericDues.push(genericDue - i);
        }

        const newGenericAnnuityData = mortgageMathService.calcAnnuityCalendar(
            {
                amount: userInfoService.annuityCalcData.amount,
                iRate: userInfoService.annuityCalcData.iRate,
                due: sanitizeInput(userInfoService.annuityCalcData.due)*12,
                installment: userInfoService.annuityCalcData.installment
            
            },

            newAnnuityData.map((val) => 0),
            userInfoService.annuityCalcData.iRates.map((val) => Number(val)),
            genericDues
        )

        setGenericAnnuityData(newGenericAnnuityData);

/*
TODO: try to fix this
        const negativeAmountAndRemainingDueIndex = newAnnuityData.findIndex((val) => (val.amount < -1 && val.due > 0));

        if (negativeAmountAndRemainingDueIndex !== -1) {
            return setTimeout(() => {
                setNewDue(negativeAmountAndRemainingDueIndex, 0);
            }, 100);
        }
*/

        if (newAnnuityData[newAnnuityData.length-1].amount < -1 || newAnnuityData[newAnnuityData.length-1].amount > 1) {
            // Last year differnce
            const lastYearExtraAmount = userInfoService.annuityCalcData.extraAmountsOfPayments[newAnnuityData.length-1] ?? 0;
            const newLastYearExtraAmount = lastYearExtraAmount - newAnnuityData[newAnnuityData.length-1].amount;
            // By the difference amount we need to change the last years extra amount to be sure the zero
            // due is reached
            setTimeout(() => {
                setOneExtraAmountOrPayment(newLastYearExtraAmount.toString(), newAnnuityData.length-1);
                setTimeout(() => {
                    setNewDue(0, newAnnuityData.length-1);
                }, 100);
                console.error('newLastYearExtraAmount', newLastYearExtraAmount);
            }, 100);
        } else {
            // We need to check if ANY year has negative amount and if yes, set its extra amount
            // so that the zero due is reached and also set the due for that year to 0
            const negativeAmountIndex = newAnnuityData.findIndex((val) => (val.amount < -1));
            if (negativeAmountIndex !== -1) {
                const lastYearExtraAmount = userInfoService.annuityCalcData.extraAmountsOfPayments[negativeAmountIndex] ?? 0;
                const newLastYearExtraAmount = lastYearExtraAmount - newAnnuityData[negativeAmountIndex].amount;
                setOneExtraAmountOrPayment(newLastYearExtraAmount.toString(), negativeAmountIndex);
                setTimeout(() => {
                    setNewDue(0, negativeAmountIndex);
                }, 100);
            }
            setRecomputeRandomString(Math.random().toString());
        }
    })

    const setArraysWithDefaults = action((overrideDues = false, overrideExtraPayments = false, overrideIrates = false) => {
        const extraPaymentsResult: number[] = [];
        const iRatesResult: number[] = [];
        const duesResult: number[] = [];
        if (userInfoService.annuityCalcData.due === undefined) {
            return;
        }

//        const due = overrideDues ? sanitizeInput(userInfoService.annuityCalcData.due)*12 : userInfoService.annuityCalcData.dues.length;
//        const iRate = sanitizeInput(userInfoService.annuityCalcData.iRate ?? 0);
/*
        for (let i = 0; i <= due; i++) {

            if (userInfoService.annuityCalcData.extraAmountsOfPayments[i] === undefined || overrideExtraPayments) {
                extraPaymentsResult.push(0);
            } else {
                extraPaymentsResult.push(userInfoService.annuityCalcData.extraAmountsOfPayments[i]);
            }

            if (userInfoService.annuityCalcData.iRates[i] === undefined || overrideIrates) {
                iRatesResult.push(iRate);
            } else {
                iRatesResult.push(userInfoService.annuityCalcData.iRates[i] || userInfoService.annuityCalcData.iRates[i-1]);
            }

            if (userInfoService.annuityCalcData.dues[i] === undefined || overrideDues) {
                duesResult.push(due - i);
            } else {
                duesResult.push(userInfoService.annuityCalcData.dues[i]);
            }
        }
*/
        userInfoService.annuityCalcData.extraAmountsOfPayments = extraPaymentsResult;
//        setExtraAmountsOrPayments(extraPaymentsResult);
        userInfoService.annuityCalcData.iRates =  iRatesResult;
        userInfoService.annuityCalcData.dues = duesResult;
//        setDues(duesResult);
    });

    // This is a hack to ensure tha the print header is shown after the page is loaded
    useEffect(() => {
        setTimeout(() => {
            setShowPrintHeader(true);
        }, 1000);
    }, []);

    useEffect(() => {
        setArraysWithDefaults(true, true, true);
        recompute();
    }, []);

    useEffect(() => {
        recompute();
    }, [userInfoService.annuityCalcData.extraAmountsOfPayments, userInfoService.annuityCalcData.iRates, userInfoService.annuityCalcData.dues]);

    const setDateType = action((isMonthlyData: boolean) => {
        // I don't think we need to reset the dues anymore after refactoring, where only the
        // changed dues are set
//        userInfoService.annuityCalcData.dues = [];
        setMonthlyData(isMonthlyData);
    });

    const setNewDue = action((newDue: number, index: number) => {
        const previousDue = getMostRecentNumericValue(userInfoService.annuityCalcData.dues, index-1, true);
        const diffWithIndex = previousDue - newDue + (monthlyData ? 0 : 11);

        const originalDue = sanitizeInput(userInfoService.annuityCalcData.due ?? 0)*12;

        let newDues = [...userInfoService.annuityCalcData.dues];
        newDues[index] = newDue;
        if (monthlyData) {
            if (index >= 1 && 
                (
                    diffWithIndex === 1
                    ||
                    (!previousDue && originalDue - index === newDue)
                )
            ) {
                delete newDues[index];
            }
        } else {
            if (index >= 12 && 
                (
                    diffWithIndex === 12
                    ||
                    (!previousDue && originalDue - index === newDue)
                )
            ) {
                delete newDues[index];
            }
        }

        userInfoService.annuityCalcData.dues = newDues;
    });

    const deleteIrate = action((index: number) => {
        const newIRates = [...userInfoService.annuityCalcData.iRates];
        delete newIRates[index];
        userInfoService.annuityCalcData.iRates = newIRates;
    });

    const setNewIRate = action((newIRate: number, index: number) => {
        const newIRates = [...userInfoService.annuityCalcData.iRates];
        newIRates[index] = newIRate;
        const mostRecentIrate = getMostRecentNumericValue(userInfoService.annuityCalcData.iRates, index-1);

        if (!mostRecentIrate) {
            if (newIRate === sanitizeInput(userInfoService.annuityCalcData.iRate ?? 0)) {
                delete newIRates[index];
            }
        }

        if (newIRate === getMostRecentNumericValue(userInfoService.annuityCalcData.iRates, index-1)) {
            delete newIRates[index];
        }

        userInfoService.annuityCalcData.iRates = newIRates;
    });

    const setDefaultsAndRecompute = action(() => {
//        setArraysWithDefaults(true, true, true);
        recompute();
    });

    const recomputeDue = action((index: number) => {
        // Compute new due and set the due for the next index.. I guess?
        try {
            const newDue = mortgageMathService.calcMortgageViaMissingParam({
                amount: annuityData[index].amount,
                iRate: annuityData[index].iRate,
                installment: annuityData[index].installment,
    //            due: annuityData[index].due
            }, false);
    
            const newDueInMonths = newDue*12;
            // Set new due for the next index
            setNewDue(newDueInMonths, index);
        } catch(e) {
            alert('Pro toto zadání nelze vypočítat splatnost při zachování výše splátky: Výsledná splatnost je příliš vysoká, nebo je při dané splátce nemožné splácet jistinu.')
            console.warn(e);
        }

        return;
    });

    const multiGraph = useMemo(() => {
        return variableAmount || variableDue;
    }, [variableAmount, variableDue]);

    const result = useMemo(() => {
        if (!annuityData.length) {
            return null;
        }
        return annuityData[annuityData.length - 1];
    }, [annuityData]);

    const sumOfExtraAmountsOfPayments = useMemo(() => {
        return userInfoService.annuityCalcData.extraAmountsOfPayments.reduce((total, value) => {
            const numericValue = sanitizeInput(value ?? 0);
            if (Number.isNaN(numericValue)) {
                return total;
            }
            return total + numericValue;
        }, 0);
    }, [userInfoService.annuityCalcData.extraAmountsOfPayments]);

    function renderGraph(generic: boolean = false, small: boolean = false, print: boolean = false, printTwo: boolean = false) {

        const usedData = generic ? genericAnnuityData : annuityData;

        let chartDimensions;

        if (print) {
            if (printTwo) {
                chartDimensions = { width: 700, height: 400 };
            } else {
                chartDimensions = { width: 700, height: 600 };
            }
        } else {
            chartDimensions = small ? { width: 850, height: 550 } : { width: 900, height: 600 };
        }

        const options = {
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        color: 'rgb(0, 0, 0)'
                    }
                },
                title: {
                    display: true,
                    text: `${'Splátkový kalendář'} ${generic ? ' beze změn splatnosti a výše úvěru' : ''}`,
                    font: {
                        size: 25
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function(context: any) {
                            let label = context.dataset.label || '';
    
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits:0 }).format(context.parsed.y*1000000);
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Měsíce', // or 'Roky', depending on your x-axis meaning
                        color: 'black',
                        font: {
                            size: 14,
//                            weight: 'bold'
                        }
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: 'mil. Kč',
                        color: 'black',
                        font: {
                            size: 14,
//                            weight: 'bold'
                        }
                    }
                }
            },
            maintainAspectRatio: false,
            responsive: false
        }

        const processedData = /*monthlyData ? usedData :*/ usedData.filter((_, index) => index === 0 || index % 12 === 0);

        const data = {
            labels: processedData.map((_, index) => index),
            datasets: [
            {
                label: 'Suma plateb',
                data: processedData.map((result) => Math.round(result.sumOfPayments || 0)/1000000),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                hidden: false,
                order: 1
            },
            {
                label: 'Suma úroků',
                data: processedData.map((result) => Math.round(result.sumOfInterest || 0)/1000000),
                borderColor: 'rgb(255, 99, 0)',
                backgroundColor: 'rgba(255, 99, 0, 0.5)',
                hidden: false,
                order: 2
            },
            {
                label: 'Zbývající jistina',
                data: processedData.map((result) => Math.round(result.amount || 0)/1000000),
                borderColor: 'rgba(49, 128, 166, 0.5)', // Change border color to transparent
                backgroundColor: 'rgba(49, 128, 166, 0.5)', // Set background color for the area
                hidden: false,
                order: 3,
                fill: true,
                pointRadius: 2
            },
        ]
        };
        return <div className={`graph ${small ? "small" : ""}`}>
            <Line options={options} data={data} width={chartDimensions.width} height={chartDimensions.height}/>
        </div>

    }

    return (
        <div className='app-screen annuity-calc'>
                {
                showPrintHeader &&
                <PrintHeader 
                    title= {`${bankService.dataService.wordPressUIData.annuityCalcName ? bankService.dataService.wordPressUIData.annuityCalcName : 'Splátkový kalendář'}`}
                    subtitle= {userInfoService.general.name}
                    hideDetails = {true}
                />
            }
                    <PrintFooter
                        hideDetails = {false}
                    />
                    <ImportExport/>
                    <div className="simple-calc-wrapper">
                        <div className="print-visible w-full">
                            <div className={`print-inputs ${multiGraph ? "print-inputs-multi-graph" : ""}`}>
                                <div className="print-input-wrapper">
                                    <div className="simple-label !font-bold">
                                        Úroková sazba p. a.
                                    </div>
                                    <div className="simple-value">
                                        {userInfoService.annuityCalcData.iRate} %
                                    </div>
                                </div>

                                <div className="print-input-wrapper">
                                    <div className="simple-label !font-bold">
                                        Splatnost v letech
                                    </div>
                                    <div className="simple-value">
                                        {userInfoService.annuityCalcData.due} let
                                    </div>
                                </div>

                                <div className="print-input-wrapper">
                                    <div className="simple-label !font-bold">
                                        Výše splátky
                                    </div>
                                    <div className="simple-value">
                                        {userInfoService.annuityCalcData.installment} Kč
                                    </div>
                                </div>

                                <div className="print-input-wrapper">
                                    <div className="simple-label !font-bold">
                                        Výše úvěru
                                    </div>
                                    <div className="simple-value">
                                        {userInfoService.annuityCalcData.amount} Kč
                                    </div>
                                </div>

                            </div>
                        </div>

                    <div className="print:hidden w-full flex flex-wrap justify-center items-center bg-gray-100 pb-10">
                        <div className="simple-hypo-input-section">
                            <div className="simple-label font-bold">
                                Výše úvěru
                            </div>
                            <InputWithSlider
                                placeholder='Výše hypotéky'
                                min={100000}
                                max={10000000}
                                step={50000}
                                observable={userInfoService.annuityCalcData}
                                field={'amount'}
                                onChangeCallback = {setDefaultsAndRecompute}
                                textAfterInput = 'Kč'
                            />
                        </div>
                        <div className="simple-hypo-input-section">
                            <div className="simple-label font-bold">
                                Úroková sazba p. a.
                            </div>
                            <InputWithSlider
                                placeholder='Úroková sazba'
                                min={0.0}
                                max={10}
                                step={0.1}
                                observable={userInfoService.annuityCalcData}
                                field={'iRate'}
                                onChangeCallback = {setDefaultsAndRecompute}
                                errorMessage = {'Výsledná sazba je mimo běžné hodnoty'}
                                textAfterInput = ' %'
                                showDecimals = {true}
                            />
                        </div>
                        <div className="simple-hypo-input-section">
                            <div className="simple-label font-bold">
                                Splatnost v letech
                            </div>
                            <InputWithSlider
                                placeholder='Splatnost'
                                min={1}
                                max={40}
                                step={1}
                                observable={userInfoService.annuityCalcData}
                                field={'due'}
                                onChangeCallback = {setDefaultsAndRecompute}
                                errorMessage = {'Výsledná splatnost je vyšší než 40 let'}
                                textAfterInput = ' let'
                            />
                        </div>
                        <div className="simple-hypo-input-section">
                            <div className="simple-label font-bold">
                                Výše splátky
                            </div>
                            <InputWithSlider
                                placeholder='Výše splátky'
                                min={100}
                                max={40000}
                                step={100}
                                observable={userInfoService.annuityCalcData}
                                field={'installment'}
                                onChangeCallback = {setDefaultsAndRecompute}
                                textAfterInput = ' Kč'
                                showDecimals = {false}
                            />
                        </div>
                    </div>
                        <div className="print:!hidden simple-hypo-extra-input-section bg-gray-100">
                            <div className="extra-input-wrapper">
                                <span>Změna výše úvěru a splanosti</span>
                                <input className="checkbox" type="checkbox" onChange={(e) => {
                                    setVariableDue(e.target.checked);
                                    setVariableAmount(e.target.checked);

                                    if (!e.target.checked) {
                                        setArraysWithDefaults(true, true, false);
//                                        setArraysWithDefaults(true, false, false);
                                    }
                                }}/>
                            </div>
{/*
                            <div className="extra-input-wrapper">
                                <span>Mimořádné splátky/navýšení</span>
                                <input className="checkbox" type="checkbox" onChange={(e) => {
                                    setVariableAmount(e.target.checked);

                                    if (!e.target.checked) {
                                        setArraysWithDefaults(false, true, false);
                                    }
                                }}/>
                            </div>
*/}
                            <div className="extra-input-wrapper">
                                <span>Změna úrokové sazby</span>
                                <input className="checkbox" type="checkbox" onChange={(e) => {
                                    setVariableIRate(e.target.checked);

                                    if (!e.target.checked) {
                                        setArraysWithDefaults(false, false, true);
                                    }
                                }}/>
                            </div>

                            <div className="extra-input-wrapper">
                                <span>Poznámky</span>
                                <input className="checkbox" type="checkbox" onChange={(e) => {
                                    setNotesVisible(e.target.checked);
                                }}/>
                            </div>
{/*
                            <div className="extra-input-wrapper hidden">
                                <span className="simple-label">
                                    Kalendář:
                                </span>
                                <Select
                                    options={[
                                        {
                                            value: "false",
                                            label: "Roční"
                                        },
                                        {
                                            value: "true",
                                            label: "Měsíční"
                                        }
                                    ]}
                                    observable = {userInfoService.annuityCalcData}
                                    field = "dataMonthly"
                                    onChangeCallback = {(e: any) => {
                                        setDateType(e.target.value === "true" ? true : false)
//                                        setMonthlyData(e.target.value === "true" ? true : false)
                                    }}
                                />
                            </div>
*/}
                        </div>
                    </div>

                    <div className="print-visible w-full">
                        {
                            /*
                            This section will contain a section, that will have a few informations
                            like:
                            - Total amount of interest paid
                            - Total amount of payments made
                            - Total amount of extra payments
                            - 
                            */
                        }
                        <div className="relative flex flex-row justify-between w-full">
                            <div className="flex flex-col w-1/3">
                                <div className="simple-label !font-bold">
                                    Suma plateb
                                </div>
                                <div className="simple-value">
                                    {result ? `${numberToStringWithSpaces(Math.round(result.sumOfPayments ?? 0))} Kč` : '-'}
                                </div>
                            </div>
                            <div className="flex flex-col w-1/3">
                                <div className="simple-label !font-bold">
                                    Suma úroků
                                </div>
                                <div className="simple-value">
                                    {result ? `${numberToStringWithSpaces(Math.round(result.sumOfInterest ?? 0))} Kč` : '-'}
                                </div>
                            </div>
                            <div className="flex flex-col w-1/3">
                                <div className="simple-label !font-bold">
                                    Přeplatek v %
                                </div>
                                <div className="simple-value">
                                    {result ? `${numberToStringWithSpaces(
                                        // Round to 2 decimal places
                                        Math.round((Math.round(result.sumOfInterest ?? 0) )/(Math.round(result.sumOfPayments ?? 0) - Math.round(result.sumOfInterest ?? 0))*10000)/100
                                    ).replace(".", ",")} %` : '-'}
                                </div>
                            </div>
                            <div className="flex flex-col w-1/3">
                                <div className="simple-label !font-bold">
                                    Mimořádné platby
                                </div>
                                <div className="simple-value">
                                    {`${numberToStringWithSpaces(Math.round(sumOfExtraAmountsOfPayments ?? 0))} Kč`}
                                </div>
                            </div>
                        </div>
                        <Divider classNames="bottom-[-15px] left-0"/>

                    </div>

                    <div className="results-wrapper">
                        <RenderTable
                            annuityData={annuityData}
                            variableAmount={variableAmount}
                            variableIRate={variableIRate}
                            variableDue={variableDue}
                            userInfoService={userInfoService}
                            notesVisible={notesVisible}
                            setOneNote={setOneNote}
                            setStartingYear={setStartingYear}
                            recomputeDue={recomputeDue}
                            deleteIrate={deleteIrate}
                            setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
                            setNewIRate={setNewIRate}
                            setNewDue={setNewDue}
                            recomputeRandomString={recomputeRandomString}
                        />
                        
                        <div className={`w-[1000px] px-5 graph-wrapper ${multiGraph ? "multi-graph" : ""} print-size-none`}>
                            {renderGraph(false, !multiGraph)}
                            { multiGraph &&
                                renderGraph(true, true)
                            }
                        </div>


                        <div className={`graph-wrapper multi-graph ${multiGraph ? "print-size-some" : "size-none"} relative bottom-[60px]`}>
                            {renderGraph(false, true, true, true)}
                            {renderGraph(true, true, true, true)}
                        </div>
                        <div className={`graph-wrapper ${multiGraph ? "size-none" : "print-size-some"} mt-[100px]`}>
                            {renderGraph(false, false, true)}
                        </div>


                    </div>

                    <PrintButton/>

            <div className="calc-disclaimer">{calcDisclaimer}</div>
    </div>
)})

const RenderTable = observer((props: {
    annuityData: any[],
    variableAmount: boolean,
    variableIRate: boolean,
    variableDue: boolean,
    userInfoService: UserInfo,
    notesVisible: boolean,
    setOneNote: (note: string, index: number) => void,
    setStartingYear: (newStartingYear: number) => void,
    recomputeDue: (index: number) => void,
    deleteIrate: (index: number) => void,
    setOneExtraAmountOrPayment: (newExtraAmountOrPayment: string, index: number) => void,
    setNewIRate: (newIRate: number, index: number) => void,
    setNewDue: (newDue: number, index: number) => void,
    recomputeRandomString: string
}) => {
    const { 
        annuityData, 
        variableAmount, 
        variableIRate, 
        variableDue, 
        userInfoService, 
        notesVisible, 
        setOneNote, 
        setStartingYear, 
        recomputeDue, 
        deleteIrate, 
        setOneExtraAmountOrPayment, 
        setNewIRate, 
        setNewDue, 
        recomputeRandomString
    } = props;
    
    const [expandedYears, setExpandedYears] = useState<Record<number, boolean>>({});

    const isSomeYearExpanded = Object.values(expandedYears).some((value) => value);

    const handleYearToggle = (year: number) => {
        setExpandedYears((prev) => ({
            ...prev,
            [year]: !prev[year],
        }));
    };

    const renderTableHead = () => (
        <thead>
            <tr key="header_row" className="border-b border-gray-300">
                <th>{isSomeYearExpanded ? 'Rok/měsíc' : 'Rok'}</th>
                <th>Zůstatek úvěru</th>
                <th>Výše splátky</th>
                <th>Úrok v roce</th>
                <th>Úrok celkem</th>
                {variableAmount &&
                    <th>Změna výše úvěru +-</th>
                }
                { variableIRate &&
                    <th>Úroková sazba p. a.</th>                        
                }
                { variableDue &&
                    <th>Splatnost let/měsíců</th>
                }
            </tr>
        </thead>
    );

    const printTableGroups = useMemo(() => {
        if (!annuityData.length) {
            return [] as number[][];
        }

        const yearStartIndexes: number[] = [];

        annuityData.forEach((_, index) => {
            if (annuityData.length % 12 !== 0 && index === annuityData.length - 1) {
                yearStartIndexes.push(index);
                return;
            }

            if (index % 12 === 0) {
                yearStartIndexes.push(index);
            }
        });

        const tables: number[][] = [];
        let currentTable: number[] = [];
        let currentRowCount = 0;
        let tableIndex = 0;

        yearStartIndexes.forEach((startIndex) => {
            const yearIndex = Math.floor(startIndex / 12);
            const rowsForYear = expandedYears[yearIndex] ? 13 : 1;
            const limit = 31;

            if (currentTable.length > 0 && currentRowCount + rowsForYear > limit) {
                tables.push(currentTable);
                tableIndex += 1;
                currentTable = [];
                currentRowCount = 0;
            }

            currentTable.push(startIndex);
            currentRowCount += rowsForYear;
        });

        if (currentTable.length) {
            tables.push(currentTable);
        }

        return tables;
    }, [annuityData, expandedYears]);

    const noteEntries = (userInfoService.annuityCalcData.notes ?? [])
        .map((note, index) => {
            const value = typeof note === 'string' ? note.trim() : String(note ?? '').trim();
            if (!value) {
                return null;
            }
            return { index, note: value };
        })
        .filter((entry): entry is { index: number; note: string } => !!entry);

    const formatPeriodLabel = (idx: number) => {
        const baseYear = Number(userInfoService.annuityCalcData.startingYear) || 0;
        const yearOffset = Math.floor(idx / 12);
        const monthNumber = (idx % 12) + 1;
        const displayYear = baseYear ? baseYear + yearOffset : yearOffset + 1;
        return `${displayYear}/${monthNumber}`;
    };

    return <>
        <span className="flex items-center justify-center m-5 print-hidden">
            <table>
                {renderTableHead()}
                <tbody>
                    {
                        annuityData.map((data, index) => {
                            /*
                            if (!monthlyData && index % 12 !== 0) {
                                return null;
                            }
    */
                            const yearIndex = Math.floor(index / 12);

                            if (annuityData.length % 12 !== 0 && index === annuityData.length - 1) {
                                return (<RenderYearlyTable
                                    key={`table-${index}`}
                                    recomputeRandomString={recomputeRandomString}
                                    data={annuityData}
                                    index={index}
                                    variableAmount={variableAmount}
                                    variableIRate={variableIRate}
                                    variableDue={variableDue}
                                    userInfoService={userInfoService}
                                    notesVisible={notesVisible}
                                    setOneNote={setOneNote}
                                    setStartingYear={setStartingYear}
                                    recomputeDue={recomputeDue}
                                    deleteIrate={deleteIrate}
                                    setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
                                    setNewIRate={setNewIRate}
                                    setNewDue={setNewDue}
                                    annuityData={annuityData}
                                    yearExpanded={!!expandedYears[yearIndex]}
                                    onToggleYear={handleYearToggle}
                                    />);
                            }

                            if (index % 12 !== 0) {
                                return null;
                            }
                            return (<RenderYearlyTable
                                key={`table-${index}`}
                                recomputeRandomString={recomputeRandomString}
                                data={annuityData}
                                index={index}
                                variableAmount={variableAmount}
                                variableIRate={variableIRate}
                                variableDue={variableDue}
                                userInfoService={userInfoService}
                                notesVisible={notesVisible}
                                setOneNote={setOneNote}
                                setStartingYear={setStartingYear}
                                recomputeDue={recomputeDue}
                                deleteIrate={deleteIrate}
                                setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
                                setNewIRate={setNewIRate}
                                setNewDue={setNewDue}
                                annuityData={annuityData}
                                yearExpanded={!!expandedYears[yearIndex]}
                                onToggleYear={handleYearToggle}
                                />);
                        })
                    }
                </tbody>
            </table>
        </span>
        <div className="print-visible w-full">
            {printTableGroups.map((group, groupIdx) => (
                <div
                    key={`print-table-${groupIdx}`}
                    className={`flex items-center justify-center m-5 ${groupIdx === 0 ? "" : "pt-2"}`}
                    style={groupIdx === 0 ? undefined : { pageBreakBefore: 'always' }}
                >
                    <table>
                        {renderTableHead()}
                        <tbody>
                            {group.map((startIndex) => {
                                const yearIndex = Math.floor(startIndex / 12);
                                return (
                                    <RenderYearlyTable
                                        key={`print-${startIndex}`}
                                        recomputeRandomString={recomputeRandomString}
                                        data={annuityData}
                                        index={startIndex}
                                        variableAmount={variableAmount}
                                        variableIRate={variableIRate}
                                        variableDue={variableDue}
                                        userInfoService={userInfoService}
                                        notesVisible={notesVisible}
                                        setOneNote={setOneNote}
                                        setStartingYear={setStartingYear}
                                        recomputeDue={recomputeDue}
                                        deleteIrate={deleteIrate}
                                        setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
                                        setNewIRate={setNewIRate}
                                        setNewDue={setNewDue}
                                        annuityData={annuityData}
                                        yearExpanded={!!expandedYears[yearIndex]}
                                        onToggleYear={handleYearToggle}
                                    />
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
            {noteEntries.length > 0 && (
                <div
                    key="print-notes"
                    className="flex flex-col items-center justify-start m-5 w-full"
                    style={{ pageBreakBefore: 'always' }}
                >
                    <table className="w-full relative top-[30px] mb-5 !mt-0 pt-[80px]">
                        <thead>
                            <tr>
                                <th className="!w-[120px]">Období (Rok/měsíc)</th>
                                <th className="!w-[600px] print-hidden">Poznámka</th>
                            </tr>
                        </thead>
                        <tbody>
                            {noteEntries.map(({ index, note }) => (
                                <tr key={`note-entry-${index}`}>
                                    <td>{formatPeriodLabel(index)}</td>
                                    <td className="py-2">{note}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    </>;
});

const RenderTableRow = observer((props: {
    data: any,
    index: number,
    hidden?: boolean,
    toggleExpanded?: () => void,
    yearExpanded?: boolean,
    variableAmount: boolean,
    variableIRate: boolean,
    variableDue: boolean,
    userInfoService: UserInfo,
    notesVisible: boolean,
    setOneNote: (note: string, index: number) => void,
    setStartingYear: (newStartingYear: number) => void,
    recomputeDue: (index: number) => void,
    annuityData: any[],
    deleteIrate: (index: number) => void,
    setOneExtraAmountOrPayment: (newExtraAmountOrPayment: string, index: number) => void,
    setNewIRate: (newIRate: number, index: number) => void,
    setNewDue: (newDue: number, index: number) => void,
    recomputeRandomString: string
}) => {
    const { data, index, hidden = false, toggleExpanded, yearExpanded = false, variableAmount, variableIRate, variableDue, userInfoService, notesVisible, setOneNote, setStartingYear, recomputeDue, annuityData, deleteIrate, setOneExtraAmountOrPayment, setNewIRate, setNewDue, recomputeRandomString } = props;
    
    if (hidden) {
        return null;
    }

    const isEdited = () => {
        const theExactRowIsEdited = !!userInfoService.annuityCalcData.extraAmountsOfPayments[index] || 
            !(index === 0 || !userInfoService.annuityCalcData.iRates[index]) ||
            !(index === 0 || !userInfoService.annuityCalcData.dues[index])

        if (theExactRowIsEdited) {
            return true;
        }

        // By toggleExpanded we can tell if this is the overall yearly row or the monthly row
        if (toggleExpanded && annuityData) {
            // If any of the monthly data in given year is edited, return true
            for (let i = 0; i < 12; i++) {
                if (userInfoService.annuityCalcData.extraAmountsOfPayments[index - i] ||
                    userInfoService.annuityCalcData.iRates[index - i] ||
                    userInfoService.annuityCalcData.dues[index - i]) {
                    return true;
                }
            }
        }

        return false;
    }

    return <AnnuityCalcTableRow 
        key={index + " " + recomputeRandomString}
        toggleExpanded={toggleExpanded}
        yearExpanded={yearExpanded}
        nrOfPeriod={toggleExpanded ? index/12 : `${(index % 12 === 0 ? 12 : index % 12)}/${Math.ceil(index/12) +userInfoService.annuityCalcData.startingYear - (userInfoService.annuityCalcData.startingYear === 0 ? 0 : 1)}`}
        data={data}
        index={index}
        installment={numberToStringWithSpaces(Math.round(annuityData[index]?.installment ? annuityData[index].installment : 0))}
        interest={numberToStringWithSpaces(Math.round(annuityData[index]?.interest ? annuityData[index].interest : 0))}
        sumOfInterest={numberToStringWithSpaces(Math.round(annuityData[index]?.sumOfInterest ? annuityData[index].sumOfInterest : 0))}
        variableAmount={variableAmount}
        variableIRate={variableIRate}
        variableDue={variableDue}
        edited={isEdited()}
        editedFields={[
            userInfoService.annuityCalcData.extraAmountsOfPayments[index] ? 'extraAmountsOfPayments' : '',
            userInfoService.annuityCalcData.iRates[index] !== undefined ? 'iRates' : '',
            userInfoService.annuityCalcData.dues[index] !== undefined ? 'dues' : '',
        ]}
        deleteIrate={deleteIrate}
        extraAmountOrPayment={userInfoService.annuityCalcData.extraAmountsOfPayments[index] ? userInfoService.annuityCalcData.extraAmountsOfPayments[index] : 0}
        setExtraAmountOrPayment={setOneExtraAmountOrPayment}
        iRate={
            getMostRecentNumericValue(userInfoService.annuityCalcData.iRates, index)
            ?? (sanitizeInput(userInfoService.annuityCalcData.iRate ?? 0) )
        }
        setNewIRate={setNewIRate}
        due={
            true ?
                (
                    getMostRecentNumericValue(userInfoService.annuityCalcData.dues, index, true) !== undefined ?
                    getMostRecentNumericValue(userInfoService.annuityCalcData.dues, index, true)
                    :
                    (sanitizeInput(userInfoService.annuityCalcData.due ?? index)*12 - index)
                ) :
                (
                    getMostRecentNumericValue(userInfoService.annuityCalcData.dues, index, true) !== undefined ?
                    getMostRecentNumericValue(userInfoService.annuityCalcData.dues, index, true)/12
                    :
                    (sanitizeInput(userInfoService.annuityCalcData.due ?? index) - index/12)
                )
        }
        setNewDue={setNewDue}
        monthlyData={true}
        notesOn={notesVisible}
        note={userInfoService.annuityCalcData.notes[index] ? userInfoService.annuityCalcData.notes[index] : ""}
        setNote={setOneNote}
        startingYear={userInfoService.annuityCalcData.startingYear}
        setStartingYear={setStartingYear}
        recomputeDue={recomputeDue}
    />
});

const RenderYearlyTable = observer((props: {
        data: any[],
        index: number,
        variableAmount: boolean,
        variableIRate: boolean,
        variableDue: boolean,
        userInfoService: UserInfo,
        notesVisible: boolean,
        setOneNote: (note: string, index: number) => void,
        setStartingYear: (newStartingYear: number) => void,
        recomputeDue: (index: number) => void, annuityData: any[],
        deleteIrate: (index: number) => void,
        setOneExtraAmountOrPayment: (newExtraAmountOrPayment: string, index: number) => void,
        setNewIRate: (newIRate: number, index: number) => void,
        setNewDue: (newDue: number, index: number) => void,
        recomputeRandomString: string,
        yearExpanded: boolean,
        onToggleYear: (year: number) => void
    }) => {
    // 0 = first year
    // 12 = second year
    // etc.
    const {data, index, variableAmount, variableIRate, variableDue, userInfoService, notesVisible, setOneNote, setStartingYear, recomputeDue, annuityData, deleteIrate, setOneExtraAmountOrPayment, setNewIRate, setNewDue, recomputeRandomString, yearExpanded, onToggleYear} = props;
    const year = Math.floor(index / 12);
    const nrOfMonthsInYear = index % 12 === 0 ? 12 : index % 12;

    const handleToggleExpand = () => {
        onToggleYear(year);
        /*
        setTimeout(() => {
            return;
            window.scrollTo({
                top: document.documentElement.scrollHeight - distanceFromBottom - window.innerHeight,
                behavior: 'smooth'
            });
        }, 1);
        */
    };

    // First year is special, we will render only the first
    if (year === 0) {
        return <RenderTableRow
            recomputeRandomString={recomputeRandomString}
            data={data[index]}
            index={index}
            variableAmount={variableAmount}
            variableIRate={variableIRate}
            variableDue={variableDue}
            userInfoService={userInfoService}
            notesVisible={notesVisible}
            setOneNote={setOneNote}
            setStartingYear={setStartingYear}
            recomputeDue={recomputeDue}
            annuityData={annuityData}
            deleteIrate={deleteIrate}
            setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
            setNewIRate={setNewIRate}
            setNewDue={setNewDue}
        />;
    }

    let relevantIndexes = [];
    for (let i = 0; i < nrOfMonthsInYear; i++) {
        relevantIndexes.push(index - i);
    }
    relevantIndexes.push(index);
    relevantIndexes.reverse();
    return <>
        {relevantIndexes.map((index, i) => (
            <RenderTableRow
                recomputeRandomString={recomputeRandomString}
                key={index + " " + i}
                data={data[index]}
                index={index}
                hidden={i !== 0 && !yearExpanded}
                toggleExpanded={i === 0 ? handleToggleExpand : undefined}
                yearExpanded={yearExpanded}
                variableAmount={variableAmount}
                variableIRate={variableIRate}
                variableDue={variableDue}
                userInfoService={userInfoService}
                notesVisible={notesVisible}
                setOneNote={setOneNote}
                setStartingYear={setStartingYear}
                recomputeDue={recomputeDue}
                annuityData={annuityData}
                deleteIrate={deleteIrate}
                setOneExtraAmountOrPayment={setOneExtraAmountOrPayment}
                setNewIRate={setNewIRate}
                setNewDue={setNewDue}
            />
        ))}
    </>
});